import React, { FC } from 'react';
import { Box, BoxProps } from '@mui/material';

export interface TruncatedBoxProps extends Omit<BoxProps, 'children'> {
  /**
   * The text content to display
   */
  children: React.ReactNode;
  /**
   * Number of lines to show before truncating
   */
  lines?: number;
}

export const TruncatedBox: FC<TruncatedBoxProps> = ({
  children,
  lines = 2,
  ...boxProps
}) => {
  return (
    <Box
      {...boxProps}
      sx={{
        display: '-webkit-box',
        WebkitLineClamp: lines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...boxProps.sx,
      }}
    >
      {children}
    </Box>
  );
};
